/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';

import { IconPhotoUnavailable } from '../icons/Icons';

import Frame from './Frame';
import DivImage from './DivImage';

const IMAGE_URL = `${process.env.CDN}/img/global/unavailable/image-unavailable.jpg`;

export default function FauxUnavailableImage({
    src = IMAGE_URL,
    className,
    altText = "Photo unavailable",
    aspectRatio,
    style,
    ...rest
}) {
    if (aspectRatio) {
        return (
            <Frame
                data-sarsa-faux-unavailable-image
                aspectRatio={aspectRatio}
                className={className}
                style={style}
            >
                <div>
                    <DivImage
                        src={src}
                        altText={altText}
                        {...rest}
                    />
                    <figure>
                        <IconPhotoUnavailable size="lg" />
                        <figcaption>Photo unavailable</figcaption>
                    </figure>
                </div>
            </Frame>
        );
    }

    return (
        <div
            data-sarsa-faux-unavailable-image
            className={className}
            style={style}
            {...rest}>
            <div>
                <DivImage
                    src={src}
                    altText={altText}
                    className={className}
                />
                <figure>
                    <IconPhotoUnavailable size="lg" />
                    <figcaption>Photo Unavailable</figcaption>
                </figure>
            </div>
        </div>
    );
}

FauxUnavailableImage.propTypes = {
    /** The image URL */
    src: PropTypes.string,

    /** Text to use as the accessible label */
    altText: PropTypes.string,

    /** If provided, the image will always conform to the aspect ratio (the
     * height will change based on the width). This value MUST be provided as
     * a string with a width followed by a colon followed by a height, such
     * as "16:9" */
    aspectRatio: PropTypes.string,

    /** Additional class added to the outer container. */
    className: PropTypes.string,

    /** Additional inline style options that will be added in to what the
     * component sets internally. Try not to use this */
    style: PropTypes.object
};
